/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Spinner,
  InputGroupText,
  InputGroup,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Container } from './style';
import { api } from './../../services/api';
import Loading from 'react-loading';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './style.css';

export function Register(): React.JSX.Element {
  const history = useHistory();

  const [cpf, setCPF] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  // const [birthdate, setBirthdate] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [terms, setTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  // erros
  const [errorName, setErrorName] = useState('');
  const [errorEmail, setErrorEmail] = useState('');
  const [errorPhone, setErrorPhone] = useState('');
  // const [errorBirthDate, setErrorBirthDate] = useState('');
  const [errorCPF, setErrorCPF] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [errorPasswordConfirmation, setErrorPasswordConfirmation] = useState('');
  const [errorTerms, setErrorTerms] = useState('');

  function onChangeHandle(): void {
    setTerms(!terms);
  }

  async function handleSubmitLogin(): Promise<void> {
    if (name.length < 1) {
      setErrorName('Nome obrigatório.');
    } else {
      setErrorName('');
    }
    if (email.length < 1) {
      setErrorEmail('Email obrigatório.');
    } else if (!email.includes('@')) {
      setErrorEmail('É necessário um email válido.');
    } else if (email.split('@')[1] === '') {
      setErrorEmail('É necessário um email válido.');
    } else {
      setErrorEmail('');
    }
    if (phone.length < 1) {
      setErrorPhone('Telefone obrigatório.');
    } else {
      setErrorPhone('');
    }
    // if (birthdate.length < 1) {
    //   setErrorBirthDate('Data de nascimento obrigatório.');
    // } else {
    //   setErrorBirthDate('');
    // }

    if (password.length < 1) {
      setErrorPassword('Senha obrigatória.');
    } else if (password !== passwordConfirmation) {
      setErrorPassword('É necessário que as senhas sejam iguais.');
    } else {
      setErrorPassword('');
    }
    if (passwordConfirmation.length < 1) {
      setErrorPasswordConfirmation('Confirmação de senha obrigatória.');
    } else if (password !== passwordConfirmation) {
      setErrorPasswordConfirmation('É necessário que as senhas sejam iguais.');
    } else {
      setErrorPasswordConfirmation('');
    }

    if (!terms) {
      setErrorTerms('É necessário aceitar os termos.');
    } else {
      setErrorTerms('');
    }
    if (cpf.length !== 14) {
      setErrorCPF('CPF obrigatório.');
    } else {
      setErrorCPF('');
    }
    // if (password === '') {
    //   setErrorPassword('Senha obrigatória.');
    // } else if (password.length < 8) {
    //   setErrorPassword('Mínimo 8 caracteres.');
    // } else {
    //   setErrorPassword('');
    // }

    if (cpf.length === 14 && password !== '' && password.length >= 8) {
      // signIn({ cpf, password });
    }
    if (
      name.length !== 0 &&
      email.length !== 0 &&
      // birthdate.length !== 0 &&
      cpf.length !== 0 &&
      password.length !== 0 &&
      passwordConfirmation.length !== 0 &&
      terms &&
      password === passwordConfirmation &&
      email.includes('@') &&
      email.split('@')[1].length > 1
    ) {
      setLoading(true);
      try {
        await api.post('/auth/register', {
          name,
          accept_use_terms: terms,
          email,
          cpf,
          password,
          phone,
        });
        toast('Cadastrado com sucesso!', {
          type: 'success',
        });
        setLoading(false);
        history.push('/login');
      } catch (error) {
        setLoading(false);

        toast('Erro interno contate o administrador do sistema', {
          type: 'error',
        });
      }
    }
  }
  useEffect(() => {
    localStorage.removeItem('inputValueCpf');
    localStorage.removeItem('inputValuePassword');
  }, []);

  function cpfMask(value: string): string {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }

  function phoneMask(value: string): string {
    if (value.length === 0) return '';
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d)/, '($1) $2');
    value = value.replace(/(\d)(\d{4})$/, '$1-$2');
    return value;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#edf3ff',
      }}
    >
      {/* Imagem lateral */}
      <div
        className="d-none d-md-block"
        style={{
          width: '50%',
          height: '100vh',
        }}
      >
        <img
          src="/assets/sideImage.png"
          alt="icone-amapa"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Formulário */}
      <div
        className="col-sm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <div
          className="col-sm-7"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 20,
            height: '100%',
          }}
        >
          {/* Logo */}
          {/* <div style={{ marginTop: -30 }}>
            <img
              src="/assets/logo.png"
              alt="icone-amapa"
              className="logo"
              // style={{
              //   width: '100%', // ocupa todo o espaço possível
              //   maxWidth: '330px', // não passa disso
              //   height: 'auto', // mantém proporção
              //   objectFit: 'cover',
              // }}
            />
          </div> */}

          {/* Card do formulário */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '30px 20px',
              width: '100%',
              maxWidth: 562,
              minHeight: 456,
              gap: 20,
              maxHeight: '80vh', // altura máxima relativa à tela
              overflowY: 'auto', // ativa scroll interno quando necessário
            }}
          >
            <div style={{ marginBottom: 5, textAlign: 'center' }}>
              {/* <h5 style={{ fontWeight: 500, fontSize: 45 }}>Bem-vindo de volta!</h5> */}
              <span>Informe seus dados para fazer o login no sistema</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                  gap: 5,
                  color: '#989898',
                }}
              >
                Já sabe seu login?
                <a style={{ textDecoration: 'none', color: '#2A2C85' }} href="/login">
                  Entre
                </a>
              </div>
            </div>
            <Form style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="name"
                    style={{
                      color: errorName?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Nome
                  </Label>
                  <Input
                    style={{ borderColor: errorName?.length > 1 ? '#E44B39' : '#DEE2E6' }}
                    id="name"
                    name="name"
                    placeholder="Insira o nome"
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorName}
                  </text>
                </FormGroup>{' '}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="cpf"
                    style={{
                      color: errorCPF?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    CPF
                  </Label>
                  <Input
                    style={{ borderColor: errorCPF?.length > 1 ? '#E44B39' : '#DEE2E6' }}
                    id="exampleEmail"
                    name="email"
                    value={cpf}
                    placeholder="000.000.000-00"
                    type="text"
                    onChange={(e) => {
                      setCPF(cpfMask(e.target.value));
                    }}
                  />
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorCPF}
                  </text>
                </FormGroup>{' '}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="exampleEmail"
                    style={{
                      color: errorEmail?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Email
                  </Label>
                  <Input
                    style={{ borderColor: errorEmail?.length > 1 ? '#E44B39' : '#DEE2E6' }}
                    id="exampleEmail"
                    name="email"
                    placeholder="Insira seu email"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorEmail}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="phone"
                    style={{
                      color: errorPhone?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Telefone
                  </Label>

                  <Input
                    style={{
                      borderColor: errorPhone?.length > 1 ? '#E44B39' : '#DEE2E6',
                    }}
                    id="phone"
                    name="phone"
                    placeholder="Insira um número para contato"
                    type="tel"
                    value={phone}
                    maxLength={15}
                    onChange={(e) => {
                      setPhone(phoneMask(e.target.value));
                    }}
                  />

                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorPhone}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="password"
                    style={{
                      color: errorPassword?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Senha
                  </Label>
                  <InputGroup>
                    <Input
                      style={{ borderColor: errorPassword?.length > 1 ? '#E44B39' : '#DEE2E6' }}
                      id="password"
                      name="password"
                      placeholder="Insira a senha"
                      type={showPassword1 ? 'text' : 'password'}
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <InputGroupText
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setShowPassword1(!showPassword1);
                      }}
                    >
                      {showPassword1 ? <FaEyeSlash /> : <FaEye />}
                    </InputGroupText>
                  </InputGroup>
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorPassword}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup style={{ width: '100%', maxWidth: 452 }}>
                  <Label
                    for="passwordConfirmation"
                    style={{
                      color: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#2C2C2D',
                    }}
                  >
                    Confirmar senha
                  </Label>
                  <InputGroup>
                    <Input
                      style={{
                        borderColor: errorPasswordConfirmation?.length > 1 ? '#E44B39' : '#DEE2E6',
                      }}
                      id="passwordConfirmation"
                      name="passwordConfirmation"
                      placeholder="Confirme a senha"
                      type={showPassword2 ? 'text' : 'password'}
                      value={passwordConfirmation}
                      onChange={(e) => {
                        setPasswordConfirmation(e.target.value);
                      }}
                    />
                    <InputGroupText
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setShowPassword2(!showPassword2);
                      }}
                    >
                      {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                    </InputGroupText>
                  </InputGroup>
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorPasswordConfirmation}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <FormGroup check style={{ width: '100%', maxWidth: 452 }}>
                  <Label check>
                    <Input checked={terms} onChange={onChangeHandle} type="checkbox" /> Eu aceito os
                    termos de uso e política de privacidade
                  </Label>
                  <br />
                  <text
                    style={{
                      fontSize: 14,
                      color: '#E44B39',
                      marginBottom: 5,
                    }}
                  >
                    {errorTerms}
                  </text>
                </FormGroup>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                <Button
                  color="primary"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={async () => {
                    await handleSubmitLogin();
                  }}
                  disabled={loading}
                  style={{
                    width: '100%',
                    maxWidth: 452,
                    backgroundColor: '#2A2C85',
                    color: '#fff',
                    height: 48,
                  }}
                >
                  {loading ? <Spinner type="border" size={'sm'} color="light" /> : 'Cadastrar'}
                </Button>{' '}
              </div>
            </Form>{' '}
          </div>
        </div>
      </div>
    </div>
  );
}
